import React, { createContext, useContext, useState, useEffect } from 'react';
import { themes } from '../mock';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Set metallic gold gradient as default theme
  const defaultTheme = themes.find(t => t.id === 'metallic-gold') || themes[0];
  const [currentTheme, setCurrentTheme] = useState(defaultTheme);

  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      const theme = themes.find(t => t.id === saved);
      if (theme) setCurrentTheme(theme);
    }
  }, []);

  const changeTheme = (themeId) => {
    const theme = themes.find(t => t.id === themeId);
    if (theme) {
      setCurrentTheme(theme);
      localStorage.setItem('theme', themeId);
    }
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--theme-primary', currentTheme.primary);
    document.documentElement.style.setProperty('--theme-secondary', currentTheme.secondary);
    if (currentTheme.gradient) {
      document.documentElement.style.setProperty('--theme-gradient', currentTheme.gradient);
    } else {
      document.documentElement.style.setProperty('--theme-gradient', currentTheme.primary);
    }
  }, [currentTheme]);

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};